module.exports = __webpack_public_path__ + "img/delivery.7a3011d2.svg";